import { HEADER_TYPES, IHeader } from '@monofront/business/constants';
import DefaultHeader from './DefaultHeader';
import HeaderLightWithCTA from './HeaderLightWithCTA';
import HeaderCheckout from '../../LayoutCheckout/HeaderCheckout';
import React from 'react';
import { ICheckoutSteps } from '@hooks/useCheckoutSteps';

interface IHeaderProps {
  content?: IHeader;
}

const Header: React.FC<IHeaderProps> = ({ content }) => {
  switch (content?.type) {
    case HEADER_TYPES.DEFAULT:
      return <DefaultHeader />;
    case HEADER_TYPES.LIGHT_WITH_CTA:
      return (
        <HeaderLightWithCTA
          ctaLink={content.headerLightCtaLink}
          ctaText={content.headerLightCtaText}
        />
      );
    case HEADER_TYPES.CHECKOUT:
      return (
        <HeaderCheckout
          step={ICheckoutSteps.INTERMEDIARY}
          title={content.headerCheckoutTitle}
        />
      );
    default:
      return <DefaultHeader />;
  }
};

export default Header;
